import React from 'react'
import ICSButton from '../../components/ICS/Button/ICSButton'
import { Row, ModalBody } from 'reactstrap'
import { useNavigate } from 'react-router-dom'

const LostPasswordNotConfigured = () => {
  const navigate = useNavigate()
  const handleClick = () => {
    navigate('/ui2/login')
  }

  return (
    <ModalBody>
      <Row>
        <>Please contact your administrators.</>
      </Row>
      <Row className='reset-btn-row'>
        <ICSButton
          className='reset-confirm'
          id='form_cancel'
          width={60}
          type='success'
          onClick={handleClick}
          useSubmitBehavior={false}
        >
          Okay
        </ICSButton>
      </Row>
    </ModalBody>
  )
}

export default LostPasswordNotConfigured
